module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_3_4.7f0d4bea.jpeg";